import logo from './logo.svg';
import React, {Component} from 'react';
import { BrowserRouter, Switch, Route, NavLink } from 'react-router-dom';
import { Loader, Dimmer, Progress, Input, Button } from 'semantic-ui-react';

import Video from './components/Video.js';



import { sugtstunvideoarchivelist } from './components/constants/sugtstunvideoarchivelist.js';
import { sugtstunvideoarchivesubtitles } from './components/constants/sugtstunvideoarchivesubtitles.js';


import 'semantic-ui-css/semantic.min.css'
import './App.css';
import axios from 'axios';

export const WEB_URL = "https://www.haashuka.com";
// export const API_URL = "http://0.0.0.0:5001"
export const API_URL = "https://www.inupiaqonline.com/fastapi/"
// export const API_URL = "http://localhost:5000";

// let dictionary = [];

// let usagedictionary = [];
// var usagedictionary_dict = {};

// let postbaseusage = {};
// let postbaseusagelist = [];

let audiolibrary = [];
// let demonstrativedata = {};
let examplesentenceaudio1 = [];
let conversational2 = [];
let phrasebookaudio3 = [];
let oneandtwo = [];
let twoandthree = [];
let oneandthree = [];

let urlDictionary = {}
let dictionarySearchList = []
let audioSearchList = [];
let examples_parse = {}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dictionarySearchList:[],
      audioSearchList: [],
      audiolibrary:[],
      urlDictionary: {},
      examples_parse:{},
      passwordGood:true,

      // dictionarydict: {},
      // postbaseusage:{},
      // postbaseusagelist:[],
      // usagedictionary: [],
      // usagedictionary_dict: {},
      // demonstrativedata: {},
      innerWidth:window.innerWidth,
      innerHeight:window.innerHeight,
      progressData1:0,
      progressData2:0,
      progressData3:0,
      progressData4:0,
      fullProgress:0,
      videoList:sugtstunvideoarchivelist,
      srts:sugtstunvideoarchivesubtitles,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.progressData1 !== prevState.progressData1 || this.state.progressData2 !== prevState.progressData2 || this.state.progressData3 !== prevState.progressData3) {
      this.setState({fullProgress:((this.state.progressData1+this.state.progressData2+this.state.progressData3)/12616540)*100})
    }
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ innerWidth: window.innerWidth, innerHeight: window.innerHeight });
  };


  render() {
    // console.log(window.innerHeight)
    console.log(this.state)
    return(
    <BrowserRouter>
    <div>
{/*        {!this.state.passwordGood ?
              <Dimmer active>
                <div style={{width:'300px'}}>
                <Input
                  placeholder="Type passcode"
                  // action={{ icon: (this.state.yugtunAnalyzer ? 'search' : null), transparent:true,size:'huge', onClick: () => 
                  // {this.state.yugtunAnalyzer ? this.inputClicked() : null}
                  // }}
                  // icon={<Icon name='x' onClick={console.log('hi')} link />}
                  // iconPosition='right'
                  size='huge'
                  spellcheck="false"
                  onChange={(event, data)=>{this.setState({'password':data.value})}}
                  // value={this.state.search}
                  // onKeyPress={this.onKeyPress}
                  fluid 
                  action={{
                    content: "Enter",
                    onClick: (event, data) => (this.state.password.toLowerCase() == 'aan' ? this.setState({passwordGood:true}):null)
                  }}
                   />    
              </div>
              </Dimmer>
              :
              null
        }
        {
            this.state.passwordGood && Object.keys(this.state.examples_parse).length !== 0 && this.state.dictionarySearchList.length !== 0 && this.state.audiolibrary.length !== 0 && this.state.audioSearchList.length !== 0 && Object.keys(this.state.urlDictionary).length !== 0 ?*/}
            <Switch>

              <Route exact path='/video/:word' render={(props) => <Video {...props} videoList={this.state.videoList} srts={this.state.srts} />} />

            </Switch>     
{/*            :
            (this.state.passwordGood ?
              <div>
              <Dimmer style={{height:(window.innerHeight > 870 ? window.innerHeight: 870)}} active>
                <Loader style={{marginTop:-((870-window.innerHeight)/2)}} size='massive'>
                  Loading...
                <Progress style={{marginTop:20}} percent={this.state.fullProgress} size='tiny' />
                </Loader>
              </Dimmer>
              </div>
              :
              null
            )
        }*/}

    </div>
    </BrowserRouter>
    );
  }
};

export default App;
